/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) Progress Bar
 * @module web/components/ImportProgressModal
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap'; // 引入 Bootstrap 组件
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'; // 引入 CircularProgressbar 组件
import 'react-circular-progressbar/dist/styles.css'; // 引入 CircularProgressbar 样式

const ImportProgressModal = ({ isOpen, progress, statusMessage, onClose }) => {
    return (
        <Modal show={isOpen} centered onHide={onClose}>
            <Modal.Header>
                <Modal.Title>Import Progress</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ width: '100px', margin: '0 auto' }}>
                    <CircularProgressbar
                        value={progress}
                        text={`${progress}%`}
                        styles={buildStyles({
                            textColor: '#000',
                            pathColor: '#007bff',
                            trailColor: '#d6d6d6',
                        })}
                    />
                </div>
                <p className="mt-3 text-center">{statusMessage}</p>
            </Modal.Body>
        </Modal>
    );
};

ImportProgressModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    progress: PropTypes.number.isRequired,
    statusMessage: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ImportProgressModal;
